import { useTranslation } from 'react-i18next';

const VIDEOS = [
  {
    id: 'sj2PCzHT-Qo',
    source: 'Euronews България',
    headlineKey: 'video.headline1',
    dateKey: 'video.date1',
  },
  {
    id: 'TDyuyDBvv2E',
    source: 'Euronews България',
    headlineKey: 'video.headline2',
    dateKey: 'video.date2',
  },
  {
    id: 'SzZWIlU21mw',
    source: 'Darik News',
    headlineKey: 'video.headline3',
    dateKey: 'video.date3',
  },
];

export default function VideoSection() {
  const { t } = useTranslation();

  return (
    <section id="video" className="relative py-20 md:py-28 bg-[#050508] overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-amber-500/5 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 text-amber-400 text-xs font-['Rajdhani'] uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            <i className="ri-live-line"></i>
            {t('video.tag')}
          </div>
          <h2 className="font-['Orbitron'] text-white font-black text-3xl md:text-5xl leading-tight">
            {t('video.title1')}
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">
              {t('video.title2')}
            </span>
          </h2>
          <p className="text-gray-400 text-sm md:text-base font-['Rajdhani'] mt-4 max-w-2xl mx-auto">
            {t('video.sub')}
          </p>
        </div>

        {/* Videos grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {VIDEOS.map((video) => (
            <div
              key={video.id}
              className="rounded-2xl overflow-hidden border border-amber-500/20"
            >
              {/* Top bar */}
              <div className="flex items-center gap-3 bg-[#0d0d14] border-b border-amber-500/20 px-4 py-3">
                <div className="flex items-center gap-1.5">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500/80"></span>
                  <span className="w-2.5 h-2.5 rounded-full bg-amber-500/80"></span>
                  <span className="w-2.5 h-2.5 rounded-full bg-green-500/80"></span>
                </div>
                <div className="flex items-center gap-2 text-gray-400 text-xs font-['Rajdhani']">
                  <i className="ri-tv-2-line text-amber-400"></i>
                  <span className="text-amber-400/80">{video.source}</span>
                </div>
                <div className="ml-auto flex items-center gap-1.5 bg-red-600/20 border border-red-500/30 text-red-400 text-[10px] font-['Rajdhani'] uppercase tracking-widest px-2.5 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></span>
                  BG
                </div>
              </div>

              {/* YouTube iframe */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube.com/embed/${video.id}?rel=0&modestbranding=1&color=white`}
                  title={t(video.headlineKey)}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>

              {/* Bottom info */}
              <div className="bg-[#0d0d14] border-t border-amber-500/20 px-4 py-3">
                <p className="text-white font-['Rajdhani'] font-bold text-sm leading-snug">
                  {t(video.headlineKey)}
                </p>
                <p className="text-gray-500 text-xs font-['Rajdhani'] mt-0.5">{t(video.dateKey)}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Link to article */}
        <div className="flex justify-center mt-8">
          <a
            href="https://dariknews.bg/novini/sviat/nasa-startira-pyrvata-pilotirana-lunna-misiia-ot-polovin-vek-nasam-2450789"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 text-amber-400 hover:text-amber-300 text-xs font-['Rajdhani'] uppercase tracking-wider border border-amber-500/30 hover:border-amber-400/50 px-5 py-2.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-external-link-line"></i>
            {t('video.readmore')}
          </a>
        </div>

        {/* Caption cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
          {[
            { icon: 'ri-rocket-2-line', key: 'video.card1' },
            { icon: 'ri-moon-line', key: 'video.card2' },
            { icon: 'ri-stock-line', key: 'video.card3' },
          ].map((card) => (
            <div
              key={card.key}
              className="flex items-center gap-3 bg-[#0d0d14] border border-amber-500/15 rounded-xl px-4 py-3"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-500/10 text-amber-400 flex-shrink-0">
                <i className={`${card.icon} text-base`}></i>
              </div>
              <p className="text-gray-300 text-xs font-['Rajdhani'] leading-snug">{t(card.key)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
